import React, { Component } from 'react';
import Home from './views/home/Index.js'
import Services from './views/services/index.js'
import Products from './views/products/index.js'
import About from './views/about/index.js'
import GalleryPhotos from './views/gallery/index.js'
import Localization from './views/localization/index.js'
// import Contact from './views/Contact/index'
import {BrowserRouter,Route,Switch} from 'react-router-dom'
import './index.css';
import './assets/css/animate.css'
class App extends Component {
  render() {
    return (
      <BrowserRouter>
      <div className="route_container">
      <Switch>
            <Route exact path={'/'}  component={Home}/>
            <Route path={'/services'}  component={Services}/>
            <Route path={'/products'}  component={Products}/>
            <Route path={'/about'}  component={About}/>
            <Route path={'/gallery'}  component={GalleryPhotos}/>
             <Route path={'/localization'}  component={Localization}/>
            {/* <Route path={'/contacts'}  component={Contact}/>  */}
        </Switch>
      </div>
      </BrowserRouter>
     );
  }
}

export default App;
